const OverviewSection = ({ children }) => children;

export default OverviewSection;
